/**
 * Hand the viewer a file to save (JIM-0908-12, "Save PDF").
 *
 * Report bytes come through the API with a bearer token, so a plain
 * `<a href download>` cannot fetch them. The caller loads the bytes, we wrap
 * them in a blob URL and click a temporary anchor. iOS Safari opens the PDF
 * in its viewer with a share sheet instead of a silent download, which is
 * the expected behaviour there.
 */

/** The filename the server suggested in Content-Disposition, if any. */
export function filenameFromDisposition(
  header: string | null | undefined,
  fallback: string
): string {
  if (!header) return fallback;
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8) {
    try {
      return decodeURIComponent(utf8[1].trim());
    } catch {
      /* fall through to the plain form */
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain ? plain[1].trim() : fallback;
}

export function saveBlob(bytes: BlobPart, filename: string, type: string) {
  const url = URL.createObjectURL(new Blob([bytes], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
